import { render } from "./index.vue?vue&type=template&id=cecaedbe"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/loading/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cecaedbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cecaedbe', __exports__)) {
    api.reload('cecaedbe', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=cecaedbe", () => {
    api.rerender('cecaedbe', render)
  })

}


export default __exports__